import FlashLib from "flashlib";

export default class ClockContainer extends FlashLib.MovieClip {
    constructor(data, displayData) {
        super(data, displayData);

        this.init();
        this.addListeners();
    }

    init() {
        this.valueText = this.getChildByName('valueText');
        this.date = new Date();
        setInterval(() => {
            this.date = new Date();
            let hour = this.date.getHours();
            let min = this.date.getMinutes();
            hour = hour < 10 ? '0' + hour : hour;
            min = min < 10 ? '0' + min : min;

            this.valueText.text = `${hour} : ${min}`;
        }, 1000);
    }

    addListeners() {

    }
}